import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useGetSegment } from "../../../Segments/hooks/useGetSegment";
import { BulkEntryRule } from "../ViewWorkflowModal/EntryRules/BulkEntryRule";

export const CommunitySegmentFilterRulesView = ({
  communitySegmentId,
}: {
  communitySegmentId: number;
}) => {
  const { data, isLoading } = useGetSegment({
    id: communitySegmentId,
  });

  if (isLoading) {
    return (
      <span className="bg-tertiary block h-4 w-full animate-pulse rounded" />
    );
  }

  const filterRules = data?.rules?.rules;

  return (
    <div className="md:flex">
      <div className="w-1/4">
        <Typography.LabelSm weight="semibold">
          {t("settings.workflows.action_messages.filter_conditions")}
        </Typography.LabelSm>
      </div>
      <div className="w-3/4">
        <BulkEntryRule rules={filterRules ?? []} />
      </div>
    </div>
  );
};
